import React from 'react';
import PropTypes from 'prop-types';
import './under-construction.scss';
import useTranslation from '../../../utils/translation-utils';

const UnderConstruction = ({ title }) => {
  const [getTranslation] = useTranslation();
  return (
    <div className="under-const-cont">
      <div className="uc-illustration" />
      <div className="uc-texts">
        <div className="uc-title">{title}</div>
        <div className="uc-message">
          {getTranslation('MSG_UNDER_CONSTRUCTION')}
        </div>
      </div>
    </div>
  );
};

UnderConstruction.propTypes = {
  title: PropTypes.string,
};

UnderConstruction.defaultProps = {
  title: 'UNDER_DEVELOPMENT',
};

export default UnderConstruction;
